import { DatapointIdStandardEnum, DatapointsEntityType } from "api/ux/src";
import { addCustomFieldsAsCols, addCustomFieldsAsDatapoints } from "components/modal/portfolio-creation-edit/helper";
import { filterTagLabels } from "components/tags/helpers";
import { InsGridAggs } from "components/widgets/grid/grid-agg-funcs";
import { CustomColumnType } from "components/widgets/grid/grid-column-types";
import { getMeasuresAndDimensionsWithCurrency } from "hooks/use-funds-page";
import { useGetCustomDatapointFields } from "hooks/widget-data/use-datapoints";
import { language } from "language/default";
const mLanguage = language.en.administration.dataAdministration.exportData.managers;
export const useMeasuresAndDimensions = (groups) => {
    const customFields = useGetCustomDatapointFields([DatapointsEntityType.Manager]);
    const datapoints = [
        { datapoint: { standard: DatapointIdStandardEnum.ManagerManagerId }, name: "Id" },
        { datapoint: { standard: DatapointIdStandardEnum.ManagerManagerName }, name: "Name" },
        { datapoint: { standard: DatapointIdStandardEnum.ManagerAssetsUnderManagement }, name: "Assets Under Management" },
        { datapoint: { standard: DatapointIdStandardEnum.ManagerCountry }, name: "Country" },
        { datapoint: { standard: DatapointIdStandardEnum.ManagerWebsite }, name: "URL" },
        { datapoint: { standard: DatapointIdStandardEnum.ManagerCurrency }, name: "Currency" }
    ];
    if (customFields) {
        addCustomFieldsAsDatapoints(customFields, datapoints);
    }
    const [managerIdDatapoint, ...mesureDatapoints] = datapoints;
    const { dimensions, measures } = getMeasuresAndDimensionsWithCurrency([...groups], mesureDatapoints);
    dimensions.push(managerIdDatapoint);
    return { dimensions, measures };
};
export const useCreateColManager = () => {
    const customFields = useGetCustomDatapointFields([DatapointsEntityType.Manager]);
    const managerCols = [
        { field: "Id", hide: true, lockVisible: true },
        { checkboxSelection: true,
            field: "Name",
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            headerName: mLanguage.name,
            sort: "asc",
            type: [CustomColumnType.InsLinkColumn] },
        { enableRowGroup: true, field: "Currency", headerName: mLanguage.currency, type: CustomColumnType.InsTextSetColumn },
        { aggFunc: InsGridAggs.totalData, field: "Assets Under Management", headerName: mLanguage.assetsUnderManagement, type: [CustomColumnType.InsMoneyColumn] },
        { enableRowGroup: true, field: "Country", headerName: mLanguage.country, type: CustomColumnType.InsTextSetColumn },
        {
            enableRowGroup: true,
            field: "tags",
            filter: "agSetColumnFilter",
            filterValueGetter: filterTagLabels,
            headerName: "Tags",
            type: [CustomColumnType.InsTagsColumn]
        }
    ];
    const cols = [...managerCols];
    addCustomFieldsAsCols(customFields, cols);
    return cols;
};
